const privadoItinerario = {
  namespaced: true,
  state: () => ({
    list: [],
    privado: null,
    hoteles: [],
    restaurantes: [],
    servicios: [],
    serviciosTipos: [],
    vehiculos: [],
    transfers: [],
    proveedores: [],
  }),
  mutations: {
    load(state, { list, privado, hoteles, restaurantes, servicios, serviciosTipos, vehiculos, transfers, proveedores }) {
      state.list = list;

      state.privado = privado;
      state.hoteles = hoteles;
      state.restaurantes = restaurantes;
      state.servicios = servicios;
      state.serviciosTipos = serviciosTipos;
      state.vehiculos = vehiculos;
      state.transfers = transfers;
      state.proveedores = proveedores;
    },
    updateList(state, list) {
      state.list = list;
    },
  },
  getters: {
    hayNuevos(state) {
      return state.list.some((item) => item.isNew || item.isEdit);
    },
    estaLiquidado(state) {
      return state.privado.idLiquidacion ? true : false;
    },
  },
  actions: {
    newItem({ commit, state }) {
      const newList = [...state.list];

      newList.push({
        idItinerario: new Date().getTime(),
        isNew: true,
        isEdit: false,
        tempFecha: state.privado.fechaLlegada || null,
        tempServicio: null,
        tempProveedor: null,
        tempHotel: null,
        tempVueloTourTren: "",
        tempGuia: null,
        tempTipo: null,
        tempRestaurante: null,
        tempObservaciones: "",
      });

      commit("updateList", newList);
    },
    editItem({ commit, state, rootState }, id) {
      const newList = state.list.map((itinerario) => {
        if (itinerario.idItinerario == id) {
          return {
            ...itinerario,
            isEdit: true,
            tempFecha: itinerario.fecha,
            tempServicio: itinerario.idServicio ? state.servicios.find((item) => item.idServicio == itinerario.idServicio) : null,
            tempProveedor: itinerario.idProveedor ? state.proveedores.find((item) => item.idProveedor == itinerario.idProveedor) : null,
            tempHotel: itinerario.idHotel ? state.hoteles.find((item) => item.idHotel == itinerario.idHotel) : null,
            tempVueloTourTren: itinerario.vueloTourTren,
            tempGuia: itinerario.idGuia ? rootState.privados.guias.find((item) => item.idPersona == itinerario.idGuia) : null,
            tempTipo: itinerario.idServicioTipo ? state.serviciosTipos.find((item) => item.idServicioTipo == itinerario.idServicioTipo) : null,
            tempRestaurante: itinerario.idRestaurante ? state.restaurantes.find((item) => item.idRestaurante == itinerario.idRestaurante) : null,
            tempObservaciones: itinerario.observaciones,
          };
        }
        return itinerario;
      });

      commit("updateList", newList);
    },
    removeItem({ commit, state }, id) {
      const newList = state.list.filter((item) => item.idItinerario != id);
      commit("updateList", newList);
    },
    saveItem({ commit, state }, { id, newId }) {
      const newList = state.list.map((item) => {
        if (item.idItinerario == id) {
          return {
            ...item,
            isNew: false,
            isEdit: false,
            idItinerario: newId,
            fecha: item.tempFecha,
            servicio: item.tempServicio.nombre,
            idServicio: item.tempServicio.idServicio,
            proveedor: item.tempProveedor.nombre,
            idProveedor: item.tempProveedor.idProveedor,
            hotel: item.tempHotel?.nombre || null,
            idHotel: item.tempHotel?.idHotel || null,
            vueloTourTren: item.tempVueloTourTren,
            guia: item.tempGuia?.nombre || "",
            idGuia: item.tempGuia?.idPersona || null,
            servicioSigla: item.tempTipo?.sigla || "",
            idServicioIpo: item.tempTipo?.idServicioTipo || null,
            restaurante: item.tempRestaurante?.nombre || "",
            idRestaurante: item.tempRestaurante?.idRestaurante || null,
            observaciones: item.tempObservaciones,
          };
        }
        return item;
      });

      commit("updateList", newList);
    },
  },
};

export default privadoItinerario;
